<template>

    <AppHead title="Check your email for a code" />

    <!-- <AlertBox v-if="$page.props.flash.success || $page.props.flash.error" :message="$page.props.flash.success || $page.props.flash.error" :type="$page.props.flash.error ? 'error' : 'success'" /> -->
    <div class="min-h-screen-ios min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 sm:bg-gray-300 text-regal-blue-900">
       <div class="sm:mx-auto sm:w-full sm:max-w-lg">
           <div class="bg-white w-full rounded-3xl">
               <div class="min-w-screen flex flex-col items-center justify-center p-8 space-y-4">
                   <div class="text-3xl font-bold tracking-tight">
                       Check your email for a code
                   </div>
                   <div class="text-center text-gray-800">
                       We’ve sent a 6-character code to <span class="font-bold">{{ email }}</span>. The code expires shortly, so please enter it soon.
                   </div>
                   <div class="">
                       <div class="flex items-center py-4">
                           <div class="grid grid-cols-3 divide-x divide-gray-600 border border-gray-600 rounded-lg">
                               <template v-for="(inputField, index) in inputFields">
                                   <div v-if="index <= 2">
                                       <input class="w-16 h-20 border-none text-center text-2xl" :class="{ 'rounded-l-lg' : index == 0, 'rounded-r-lg': index == 2}" :ref="inputField.name" type="text" v-model="inputField.value" name="" @keydown="handleKeydown(inputField, $event)" @input="handleInput(inputField, $event)" :autofocus="index == 0">
                                   </div>
                               </template>
                           </div>
                           <div class="px-2.5 text-2xl text-gray-700">
                               –
                           </div>
                           <div class="grid grid-cols-3 divide-x divide-gray-600 border border-gray-600 rounded-lg">
                               <template v-for="(inputField, index) in inputFields">
                                   <div v-if="index > 2">
                                       <input class="w-16 h-20 border-none text-center text-2xl" :class="{ 'rounded-l-lg' : index == 3, 'rounded-r-lg': index == 5}" :ref="inputField.name" type="text" v-model="inputField.value" name="" @keydown="handleKeydown(inputField, $event)" @input="handleInput(inputField, $event)">
                                   </div>
                               </template>
                           </div>
                       </div>
                       <div v-if="$page.props.flash.error" class="w-full">
                           <InlineError :message="$page.props.flash.error"/>
                       </div>
                   </div>

                   <div class="w-full text-center text-sm text-gray-700 font-medium flex justify-center space-x-1">
                       Can’t find your code? Check your spam folder!
                   </div>
               </div>
           </div>

       </div>
   </div>

</template>

<script>
    import { useForm } from '@inertiajs/inertia-vue3'
    import InlineError from '@/Shared/InlineError'
    import AlertBox from '@/Shared/AlertBox'
    import CodeInput from 'vue-verification-code-input'
    import { ref } from 'vue'

    export default {
        setup () {
            const form = useForm({
                code: '',
            })

            const first = ref('')
            const rest = ref([])

            const inputFields = [
                {
                    name: 'one',
                    index: 0,
                    value: null,
                },
                {
                    name: 'two',
                    index: 1,
                    value: null,
                },
                {
                    name: 'three',
                    index: 2,
                    value: null,
                },
                {
                    name: 'four',
                    index: 3,
                    value: null,
                },
                {
                    name: 'five',
                    index: 4,
                    value: null,
                },
                {
                    name: 'six',
                    index: 5,
                    value: null,
                },
            ]

            return { form, inputFields, first, rest}
        },
        mounted() {
            // const inputElements = [...document.querySelectorAll('input.code-input')]
            // inputElements.forEach((ele,index)=>{
            //     ele.addEventListener('keydown',(e)=>{
            //         if(e.keyCode === 8 && e.target.value==='') inputElements[Math.max(0,index-1)].focus()
            //     })
            //     ele.addEventListener('input',(e)=>{
            //         const [first,...rest] = e.target.value
            //         e.target.value = first ?? ''
            //         if(index!==inputElements.length-1 && first!==undefined) {
            //             inputElements[index+1].focus()
            //             inputElements[index+1].value = rest.join('')
            //             inputElements[index+1].dispatchEvent(new Event('input'))
            //         }
            //     })
            // })
        },
        components: { InlineError, AlertBox, CodeInput },
        props: {
            email: String,
            token: String,
        },
        methods: {
            handleKeydown(inputField, e) {
                // console.log(e, this.$refs[this.inputFields[inputField.index + 1].name])
                // if (e.keyCode === 8 && e.target.value==='') {
                //     console.log(true)
                // }
                if(e.keyCode === 8 && e.target.value==='') this.$refs[this.inputFields[Math.max(0,inputField.index - 1)].name][0].focus()
            },
            sanitizeInput(input) {
                const sanitized = input.replace('-', '').replace(' ', '')
                const [first,...rest] = sanitized
                this.first = first
                this.rest = rest
            },
            handleInput(inputField, e) {
                this.sanitizeInput(e.target.value)
                this.$refs[this.inputFields[inputField.index].name][0].value = this.first ?? ''
                if(inputField.index < this.inputFields.length - 1 && this.first !== undefined) {
                    this.$refs[this.inputFields[inputField.index + 1].name][0].focus()
                    this.$refs[this.inputFields[inputField.index + 1].name][0].value = this.rest.join('')
                    this.$refs[this.inputFields[inputField.index + 1].name][0].dispatchEvent(new Event('input'))
                }
                if (inputField.index == 5 && inputField.value) {
                    return this.verifyCode()
                }
            },
            verifyCode() {
                this.form.code = ''
                for (var i = 0; i < this.inputFields.length; i++) {
                    this.form.code += this.$refs[this.inputFields[i].name][0].value.toUpperCase()
                    if (i == 2) {
                        this.form.code += '-'
                    }
                }
                // console.log(this.form.code)
                // console.log(this.token)
                if (this.token) {
                    this.form.post(route('signup.process', this.token), {
                        onSuccess: () => {
                            // this.$refs[this.inputFields[0].name].focus()
                            // for (var i = 0; i < this.inputFields.length; i++) {
                            //     this.$refs[this.inputFields[i].name].value = ''
                            // }
                        }
                    })
                } else {
                    this.form.post(route('signup.process'), {
                        onSuccess: () => {
                            // this.$refs[this.inputFields[0].name].focus()
                            // for (var i = 0; i < this.inputFields.length; i++) {
                            //     this.$refs[this.inputFields[i].name].value = ''
                            // }
                        }
                    })
                }

            }
        },
    }
</script>
